/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 let listTags = document.getElementsByClassName("magasin-list__tags")[0];
 let magasinList = document.getElementsByClassName("magasin-block");
 let regionList = [];
 let regionCounter = [];

 for (let i=0; i < magasinList.length; i++) {
   let region = magasinList[i].classList.item(3).slice(7);
   let regionIndex = regionList.indexOf(region);
   if (regionIndex === -1) {
     regionList.push(region);
     regionCounter.push(1);
   } else {
     regionCounter[regionIndex] = regionCounter[regionIndex] + 1;
   }
 }

 document.getElementsByClassName("magasins-results")[0].getElementsByTagName("span")[0].innerHTML = magasinList.length;

 for (let i=0; i < regionList.length; i++) {
   const newDiv = document.createElement("div");
   newDiv.classList.add("tag--label");
   const newContent = document.createTextNode(regionList[i] + " (" + regionCounter[i] + ")");
   newDiv.appendChild(newContent);
   listTags.appendChild(newDiv);
   newDiv.onclick = () => selectRegion(i);
 }

 function selectRegion(regionIndex) {
   let regionTags = listTags.getElementsByClassName("tag--label");
   let clear = regionTags[regionIndex].classList.contains("tag--label--accent");
   for (let i=0; i < regionTags.length; i++) {
     if (clear || (i !== regionIndex)) {
       regionTags[i].classList.remove("tag--label--accent");
     } else {
       regionTags[i].classList.add("tag--label--accent");
     }
   }
   for (let i=0; i < magasinList.length; i++) {
     if (clear || magasinList[i].classList.contains("region-" + regionList[regionIndex])) {
       magasinList[i].style.display = "inline-block";
     } else {
       magasinList[i].style.display = "none";
     }
   }
   if (clear) {
     document.getElementsByClassName("magasins-results")[0].getElementsByTagName("span")[0].innerHTML = magasinList.length;
   } else {
     document.getElementsByClassName("magasins-results")[0].getElementsByTagName("span")[0].innerHTML = regionCounter[regionIndex];
   }
 }



/**  same code for atelier list page */



 let listAteliers = document.getElementsByClassName("atelier-list-tags")[0];
 let ateliersList = document.getElementsByClassName("atelier-block");
 let atelierList = [];
 let atelierCounter = [];

 for (let i=0; i < ateliersList.length; i++) {
   let region = ateliersList[i].classList.item(3).slice(7);
   let regionIndex = atelierList.indexOf(region);
   if (regionIndex === -1) {
     atelierList.push(region);
     atelierCounter.push(1);
   } else {
     atelierCounter[regionIndex] = atelierCounter[regionIndex] + 1;
   }
 }

 document.getElementsByClassName("atelier-results")[0].getElementsByTagName("span")[0].innerHTML = ateliersList.length;

 for (let i=0; i < atelierList.length; i++) {
   const newDiv = document.createElement("div");
   newDiv.classList.add("atelier-label");
   const newContent = document.createTextNode(atelierList[i] + " (" + atelierCounter[i] + ")");
   newDiv.appendChild(newContent);
   listAteliers.appendChild(newDiv);
   newDiv.onclick = () => selectAtelier(i);
 }

 function selectAtelier(regionIndex) {
   let regionTags = listAteliers.getElementsByClassName("atelier-label");
   let clear = regionTags[regionIndex].classList.contains("atelier-label--accent");
   for (let i=0; i < regionTags.length; i++) {
     if (clear || (i !== regionIndex)) {
       regionTags[i].classList.remove("atelier-label--accent");
     } else {
       regionTags[i].classList.add("atelier-label--accent");
     }
   }
   for (let i=0; i < ateliersList.length; i++) {
     if (clear || ateliersList[i].classList.contains("region-" + atelierList[regionIndex])) {
       ateliersList[i].style.display = "inline-block";
     } else {
       ateliersList[i].style.display = "none";
     }
   }
   if (clear) {
     document.getElementsByClassName("atelier-results")[0].getElementsByTagName("span")[0].innerHTML = ateliersList.length;
   } else {
     document.getElementsByClassName("atelier-results")[0].getElementsByTagName("span")[0].innerHTML = atelierCounter[regionIndex];
   }
 }
